import Spinner from '../Spinner/Spinner';
import classes from './Button.module.css';

interface IButtonProps {
    children?: string;
    mode: 'primary' | 'secondary';
    type?: 'button' | 'submit';
    isDisabled?: boolean;
    onClick?: () => void;
    isLoading?: boolean;
    extraClass?: string;
    title?: string;
}

const Button: React.FC<IButtonProps> = ({ type = 'button', children, onClick, mode, isDisabled = false, isLoading, extraClass, title }) => {
    const btnClasses = [classes.button, classes[mode], extraClass].filter(Boolean).join(' ');
    return (
        <button disabled={isDisabled || isLoading} className={btnClasses} onClick={onClick} type={type} title={title}>
            {isLoading && <Spinner />}
            {children}
        </button>
    );
};

export default Button;
